/* ==============================================================
   LaceLinks Cart Drawer - milestones + upsell + protection
   Self-contained. No dependencies. Replaces OPUS Cart Upsell.
   ============================================================== */
(function () {
  var drawer = document.getElementById('LLCartDrawer');
  if (!drawer || drawer.dataset.llInit) return;
  drawer.dataset.llInit = '1';

  function parseJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent) || fallback; } catch (e) { return fallback; }
  }
  var cfg = parseJSON('LLCartConfig', { milestones: [], progressText: '', successText: '', upsellEnabled: false, upsellHeading: '' });
  var rules = parseJSON('LLCartUpsellData', []);

  var elItems = drawer.querySelector('[data-ll-items]');
  var elBar = drawer.querySelector('[data-ll-bar]');
  var elUpsell = drawer.querySelector('[data-ll-upsell]');
  var elCount = drawer.querySelector('[data-ll-count]');
  var elFooter = drawer.querySelector('[data-ll-footer]');
  var elCheckout = drawer.querySelector('[data-ll-checkout]');
  var elProtect = drawer.querySelector('[data-ll-protect]');
  var elNote = drawer.querySelector('[data-ll-note]');

  var isOpen = false;
  var cartCache = { items: [] };
  var busy = false;

  function money(cents) { return '$' + ((cents || 0) / 100).toFixed(2); }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Bundle discount tiers - mirror the store's active automatic discounts on the 4 core products.
  // Given the total quantity of core products, returns the % off as a fraction (highest tier wins).
  var BUNDLE_TIERS = [
    { minQty: 5, rate: 0.25 },
    { minQty: 3, rate: 0.22 },
    { minQty: 2, rate: 0.10 }
  ];
  function bundleRate(qty) {
    for (var t = 0; t < BUNDLE_TIERS.length; t++) { if (qty >= BUNDLE_TIERS[t].minQty) return BUNDLE_TIERS[t].rate; }
    return 0;
  }

  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4h13v10H1zM14 8h4l3 3v3h-7z"/><circle cx="6" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7S11 2 8 2 5 5 5 7M12 7s1-5 4-5 3 3 3 5"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
  };

  // Scroll lock via overflow only (no position:fixed pin -> no page-height collapse / scrollbar jump).
  var savedScrollY = 0;
  function open() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    isOpen = true;
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    isOpen = false;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function render(cart) {
    cartCache = cart || { items: [] };

    // The shipping-protection product is shown via the sticky toggle row,
    // not as a line item, and is excluded from the cart count.
    var protectId = elProtect ? parseInt(elProtect.dataset.productId, 10) : 0;
    function isProtect(it) { return protectId && it.product_id === protectId; }

    var displayCount = 0;
    var hasDisplayItem = false;
    (cart.items || []).forEach(function (it) {
      if (isProtect(it)) return;
      displayCount += it.quantity || 0;
      hasDisplayItem = true;
    });
    if (elCount) elCount.textContent = '(' + displayCount + ')';

    // Toggle empty-state class - CSS hides bar/upsell/note/protect.
    drawer.classList.toggle('is-empty', !hasDisplayItem);

    if (!hasDisplayItem) {
      elItems.innerHTML = '<div class="ll-cd__empty">Your cart is empty.</div>';
      if (elFooter) elFooter.hidden = true;
    } else {
      // Map preserves original index so /cart/change.js line numbers stay correct.
      elItems.innerHTML = cart.items.map(function (it, idx) {
        return isProtect(it) ? '' : renderItem(it, idx);
      }).join('');
      if (elFooter) elFooter.hidden = false;
      if (elCheckout) elCheckout.textContent = 'Checkout • ' + money(cart.total_price);
    }
    renderBar(cart);
    renderUpsell(cart);
    renderProtect(cart);
  }

  function renderBar(cart) {
    if (!elBar || !cfg.milestones || !cfg.milestones.length || !cart.items || !cart.items.length) {
      if (elBar) elBar.innerHTML = '';
      return;
    }
    var total = cart.total_price || 0;
    var max = cfg.milestones[cfg.milestones.length - 1].threshold || 1;
    var fillPct = Math.max(0, Math.min(100, (total / max) * 100));

    var next = null;
    for (var i = 0; i < cfg.milestones.length; i++) {
      if (total < cfg.milestones[i].threshold) { next = cfg.milestones[i]; break; }
    }
    var msg = next
      ? cfg.progressText.replace('[amount]', '<b>' + money(next.threshold - total) + '</b>').replace('[reward]', esc(next.label))
      : esc(cfg.successText);

    var nodes = cfg.milestones.map(function (m) {
      var pos = Math.min(100, (m.threshold / max) * 100);
      var reached = total >= m.threshold;
      return '<div class="ll-cd__node' + (reached ? ' is-reached' : '') + '" style="left:' + pos + '%">' +
               '<div class="ll-cd__node-dot">' + (ICONS[m.icon] || ICONS.gift) + '</div>' +
               '<div class="ll-cd__node-label">' + esc(m.label) + '</div>' +
             '</div>';
    }).join('');

    elBar.innerHTML =
      '<div class="ll-cd__bar-msg">' + msg + '</div>' +
      '<div class="ll-cd__track"><div class="ll-cd__track-fill" style="width:' + fillPct + '%"></div>' + nodes + '</div>';
  }

  function renderItem(item, idx) {
    var line = idx + 1;
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') + '" alt="" loading="lazy">'
      : '';
    var opts = (item.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.name) + ': <span>' + esc(o.value) + '</span>'; })
      .join(', ');

    var lineFinal = (item.final_line_price != null) ? item.final_line_price : ((item.final_price || item.price || 0) * item.quantity);
    var lineOrig = (item.original_line_price != null) ? item.original_line_price : ((item.price || 0) * item.quantity);
    var cmpUnit = item.compare_at_price || 0;
    var priceHtml;
    if (lineOrig !== lineFinal) {
      priceHtml = '<s>' + money(lineOrig) + '</s>' + money(lineFinal);
    } else if (cmpUnit > (item.price || 0)) {
      priceHtml = '<s>' + money(cmpUnit * item.quantity) + '</s>' + money(lineOrig);
    } else {
      priceHtml = money(lineOrig);
    }

    var discountHtml = '';
    var allocs = item.line_level_discount_allocations || [];
    if (allocs.length) {
      discountHtml = '<ul class="ll-cd__item-discounts">' +
        allocs.map(function (d) {
          var title = (d.discount_application && (d.discount_application.title || d.discount_application.description)) || 'Discount';
          return '<li class="ll-cd__item-discount">' + ICONS.tag + esc(title) + '</li>';
        }).join('') + '</ul>';
    }

    return '' +
      '<div class="ll-cd__item" data-line="' + line + '">' +
        '<div class="ll-cd__item-img">' + img + '</div>' +
        '<div class="ll-cd__item-main">' +
          '<div class="ll-cd__item-top">' +
            '<a class="ll-cd__item-title" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
            '<button type="button" class="ll-cd__item-trash" data-ll-remove aria-label="Remove">' + ICONS.trash + '</button>' +
          '</div>' +
          (opts ? '<div class="ll-cd__item-opt">' + opts + '</div>' : '') +
          discountHtml +
          '<div class="ll-cd__item-bottom">' +
            '<div class="ll-cd__qty">' +
              '<button type="button" class="ll-cd__qty-btn" data-ll-dec aria-label="Decrease">&minus;</button>' +
              '<span class="ll-cd__qty-val">' + item.quantity + '</span>' +
              '<button type="button" class="ll-cd__qty-btn" data-ll-inc aria-label="Increase">+</button>' +
            '</div>' +
            '<div class="ll-cd__item-price">' + priceHtml + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function starsHtml(rating) {
    var r = parseFloat(rating) || 0;
    if (r <= 0) return '';
    var pct = Math.max(0, Math.min(100, (r / 5) * 100));
    return '<div class="ll-cd__upsell-rating">' +
             '<span class="ll-cd__stars" aria-label="' + r.toFixed(1) + ' out of 5"><i style="width:' + pct + '%"></i></span>' +
             '<span class="ll-cd__rating-num">' + r.toFixed(1) + '</span>' +
           '</div>';
  }

  // ---- Upsell-card building blocks (shared by first render + stock-up product switch) ----
  function llDedupOpts(u) {
    var variants = Array.isArray(u.variants) ? u.variants : [];
    var seen = {}, opts = [];
    variants.forEach(function (v) {
      var key = v.option1 == null ? v.title : v.option1;
      if (seen[key]) return; seen[key] = true; opts.push(v);
    });
    return opts;
  }
  function llColorSelect(u) {
    var opts = llDedupOpts(u);
    if (opts.length <= 1) return '';
    var optHtml = opts.map(function (v) {
      var label = v.option1 == null ? v.title : v.option1;
      var disabled = v.available ? '' : ' disabled';
      return '<option value="' + v.id + '" data-img="' + esc(v.image || '') + '" data-price="' + (v.price || 0) + '" data-compare="' + (v.compareAt || 0) + '"' + disabled + '>' + esc(label) + (v.available ? '' : ' (sold out)') + '</option>';
    }).join('');
    var labelText = u.optionName ? esc(u.optionName) : 'Option';
    return '<select class="ll-cd__upsell-select" data-ll-upsell-select aria-label="Choose ' + labelText + '">' + optHtml + '</select>';
  }
  function llHeroImg(u) { var o = llDedupOpts(u); return (o[0] && o[0].image) ? o[0].image : (u.image || ''); }
  function llDefaultVid(u) { var o = llDedupOpts(u); return o[0] ? o[0].id : u.variantId; }
  function llPriceInner(u, rate) {
    var cmp = (u.compareAt && u.compareAt > u.price) ? '<s>' + money(u.compareAt) + '</s>' : '';
    return (rate > 0) ? money(u.price - Math.floor(u.price * rate)) + '<s>' + money(u.price) + '</s>' : money(u.price) + cmp;
  }
  function llMainHtml(u, rate) {
    var st = starsHtml(u.rating);
    return '<div class="ll-cd__upsell-title">' + esc(u.title) + '</div>' +
      '<div class="ll-cd__upsell-meta' + (st ? '' : ' ll-cd__upsell-meta--solo') + '">' +
        '<div class="ll-cd__upsell-price" data-ll-upsell-price>' + llPriceInner(u, rate) + '</div>' +
        st +
      '</div>';
  }
  function llBuildPool() {
    var pool = [], seen = {};
    for (var i = 0; i < rules.length; i++) {
      var pu = rules[i] && rules[i].upsell;
      if (pu && pu.productId && !seen[pu.productId]) { seen[pu.productId] = true; pool.push(pu); }
    }
    pool.sort(function (a, b) { return (/combat/i.test(a.title || '') ? 1 : 0) - (/combat/i.test(b.title || '') ? 1 : 0); });
    return pool;
  }

  function renderUpsell(cart) {
    if (!cfg.upsellEnabled || !elUpsell || !rules.length || !cart.items || !cart.items.length) {
      if (elUpsell) elUpsell.innerHTML = '';
      return;
    }
    var ids = cart.items.map(function (i) { return i.product_id; });

    // Distinct upsell products, boots-before-combat.
    var pool = llBuildPool();
    var poolSeen = {};
    for (var pk = 0; pk < pool.length; pk++) poolSeen[pool[pk].productId] = 1;

    // How many core upsell products are already in the cart -> which pitch to show.
    var coreInCart = 0;
    for (var ci = 0; ci < pool.length; ci++) { if (ids.indexOf(pool[ci].productId) !== -1) coreInCart++; }

    // Always surface an offer:
    // 1) correlated (a rule whose trigger is in the cart and whose product isn't),
    // 2) else the next pool product not already in the cart,
    // 3) else (everything is in the cart) a stock-up / save-on-shipping offer.
    var u = null;
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (!r || !r.upsell) continue;
      if (ids.indexOf(r.upsell.productId) !== -1) continue;
      if (r.triggerIds === 'any') { u = r.upsell; break; }
      if (Array.isArray(r.triggerIds) && r.triggerIds.some(function (id) { return ids.indexOf(id) !== -1; })) { u = r.upsell; break; }
    }
    if (!u) {
      for (var j = 0; j < pool.length; j++) {
        if (ids.indexOf(pool[j].productId) === -1) { u = pool[j]; break; }
      }
    }
    var shipping = false;
    if (!u) { u = pool[0]; shipping = true; }
    if (!u) { elUpsell.innerHTML = ''; return; }

    // Project the bundle tier for (current core quantity + 1) to price the extra pair.
    var coreQty = 0;
    for (var li = 0; li < (cart.items || []).length; li++) {
      if (poolSeen[cart.items[li].product_id]) coreQty += (cart.items[li].quantity || 0);
    }
    var bRate = bundleRate(coreQty + 1);

    var hook;
    if (shipping) {
      hook = '<div class="ll-cd__upsell-hook"><b>Stock up &amp; save.</b> Add an extra pair now and skip shipping on a second order.</div>';
    } else if (u.shortName) {
      var nm = esc(u.shortName);
      var pitch;
      if (coreInCart >= 3) {
        pitch = '<b>Complete your set.</b> Add a ' + nm + ' pair and never tie a lace again.';
      } else if (coreInCart === 2) {
        pitch = '<b>Different kicks, different laces.</b> Grab a ' + nm + ' pair so every pair is ready to slip on.';
      } else {
        pitch = '<b>82%</b> of customers grab a ' + nm + " pair to compare what's better";
      }
      hook = '<div class="ll-cd__upsell-hook">' + pitch + '</div>';
    } else {
      hook = '<div class="ll-cd__upsell-head">' + esc(cfg.upsellHeading) + '</div>';
    }

    // Stock-up card only: let the shopper pick which product to add an extra pair of.
    var productSelectHtml = '';
    if (shipping && pool.length > 1) {
      var pOptHtml = pool.map(function (pp, idx) {
        return '<option value="' + idx + '"' + (pp.productId === u.productId ? ' selected' : '') + '>' + esc(pp.title) + '</option>';
      }).join('');
      productSelectHtml = '<select class="ll-cd__upsell-select ll-cd__upsell-pselect" data-ll-product-select aria-label="Choose product">' + pOptHtml + '</select>';
    }

    elUpsell.innerHTML =
      hook +
      '<div class="ll-cd__upsell-card" data-compare="' + (u.compareAt || 0) + '" data-disc="' + bRate + '">' +
        '<div class="ll-cd__upsell-hero"><img class="ll-cd__upsell-img" data-ll-upsell-img src="' + esc(llHeroImg(u)) + '" alt="' + esc(u.title) + '" loading="lazy"></div>' +
        productSelectHtml +
        '<div data-ll-stock-main>' + llMainHtml(u, bRate) + '</div>' +
        '<div data-ll-stock-colors>' + llColorSelect(u) + '</div>' +
        '<button type="button" class="ll-cd__upsell-add" data-ll-upsell-add data-variant-id="' + llDefaultVid(u) + '" aria-label="Add ' + esc(u.title) + '">Add to Cart</button>' +
      '</div>';
  }

  function renderProtect(cart) {
    if (!elProtect) return;
    var pid = parseInt(elProtect.dataset.productId, 10);
    var on = (cart.items || []).some(function (i) { return i.product_id === pid; });
    var btn = elProtect.querySelector('[data-ll-protect-toggle]');
    if (btn) btn.classList.toggle('is-on', on);
  }

  function postChange(line, qty) {
    if (busy) return;
    busy = true;
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render).catch(function () {}).finally(function () { busy = false; });
  }

  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () { return getCart().then(render); });
  }

  function removeVariant(id) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(render);
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-ll-close]')) { close(); return; }

    var itemEl = e.target.closest('.ll-cd__item');
    if (itemEl) {
      var line = parseInt(itemEl.dataset.line, 10);
      var item = cartCache.items[line - 1];
      if (!item) return;
      if (e.target.closest('[data-ll-inc]')) { postChange(line, item.quantity + 1); return; }
      if (e.target.closest('[data-ll-dec]')) { postChange(line, item.quantity - 1); return; }
      if (e.target.closest('[data-ll-remove]')) { postChange(line, 0); return; }
    }

    var addBtn = e.target.closest('[data-ll-upsell-add]');
    if (addBtn && !busy) {
      var card = addBtn.closest('.ll-cd__upsell-card');
      var sel = card && card.querySelector('[data-ll-upsell-select]');
      var vid = sel ? sel.value : addBtn.dataset.variantId;
      busy = true; addBtn.disabled = true;
      addVariant(vid, 1).catch(function () {}).finally(function () { busy = false; addBtn.disabled = false; });
      return;
    }

    var pt = e.target.closest('[data-ll-protect-toggle]');
    if (pt && elProtect && !busy) {
      busy = true;
      var vid2 = elProtect.dataset.variantId;
      var isOn = pt.classList.contains('is-on');
      var act = isOn ? removeVariant(vid2) : addVariant(vid2, 1);
      act.catch(function () {}).finally(function () { busy = false; });
      return;
    }
  });

  // Dropdown changes: product picker (stock-up card) swaps the whole card; color picker swaps image + price.
  if (elUpsell) {
    elUpsell.addEventListener('change', function (e) {
      var pSel = e.target.closest('[data-ll-product-select]');
      if (pSel) {
        var pcard = pSel.closest('.ll-cd__upsell-card');
        if (!pcard) return;
        var poolNow = llBuildPool();
        var np = poolNow[parseInt(pSel.value, 10) || 0];
        if (!np) return;
        var prate = parseFloat(pcard.getAttribute('data-disc')) || 0;
        var pimg = pcard.querySelector('[data-ll-upsell-img]');
        if (pimg) pimg.src = llHeroImg(np);
        var pmain = pcard.querySelector('[data-ll-stock-main]');
        if (pmain) pmain.innerHTML = llMainHtml(np, prate);
        var pcolors = pcard.querySelector('[data-ll-stock-colors]');
        if (pcolors) pcolors.innerHTML = llColorSelect(np);
        var paddBtn = pcard.querySelector('[data-ll-upsell-add]');
        if (paddBtn) { paddBtn.setAttribute('data-variant-id', llDefaultVid(np)); paddBtn.setAttribute('aria-label', 'Add ' + np.title); }
        pcard.setAttribute('data-compare', np.compareAt || 0);
        return;
      }

      var sel = e.target.closest('[data-ll-upsell-select]');
      if (!sel) return;
      var opt = sel.options[sel.selectedIndex];
      var card = sel.closest('.ll-cd__upsell-card');
      if (!opt || !card) return;
      var img = card.querySelector('[data-ll-upsell-img]');
      var newImg = opt.getAttribute('data-img');
      if (img && newImg) img.src = newImg;
      var addBtn = card.querySelector('[data-ll-upsell-add]');
      if (addBtn) addBtn.setAttribute('data-variant-id', sel.value);
      var priceEl = card.querySelector('[data-ll-upsell-price]');
      if (priceEl) {
        var p = parseInt(opt.getAttribute('data-price'), 10) || 0;
        var comp = parseInt(opt.getAttribute('data-compare'), 10) || 0;
        if (!comp) comp = parseInt(card.getAttribute('data-compare'), 10) || 0;
        var rate = parseFloat(card.getAttribute('data-disc'));
        if (p && rate && rate > 0) {
          priceEl.innerHTML = money(p - Math.floor(p * rate)) + '<s>' + money(p) + '</s>';
        } else if (p) {
          priceEl.innerHTML = money(p) + (comp > p ? '<s>' + money(comp) + '</s>' : '');
        }
      }
    });
  }

  if (elNote) {
    var noteTimer;
    elNote.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: elNote.value })
        }).catch(function () {});
      }, 500);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('a[href="/cart"], a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, [data-ll-open-cart]');
    if (!t) return;
    e.preventDefault();
    getCart().then(function (cart) { render(cart); open(); });
  });

  document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && isOpen) close(); });

  function onAdd() { getCart().then(function (cart) { render(cart); open(); }); }
  var addRe = /\/cart\/add(\.js|\?|$)/i;
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0];
      var p = origFetch.apply(this, arguments);
      try { if (typeof url === 'string' && addRe.test(url)) p.then(function (res) { if (!res || res.ok !== false) setTimeout(onAdd, 60); }, function () {}); } catch (e) {}
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { if (typeof url === 'string' && addRe.test(url)) this.addEventListener('load', function () { setTimeout(onAdd, 60); }); } catch (e) {}
    return origOpen.apply(this, arguments);
  };

  getCart().then(render).catch(function () {});
})();
